import axios from 'axios';
import environment from '../environment/environment';

// Create axios instance with default config
export const axiosInstance = axios.create();

export function setAuthHeader(token?: string) {
  // In public mode, never use tokens
  if (environment.publicMode) {
    delete axiosInstance.defaults.headers.common['Authorization'];
    return;
  }

  // If token is provided, store it
  if (token) {
    localStorage.setItem('access_token', token);
  }

  // Get token from storage
  const storedToken = localStorage.getItem('access_token');
  
  // Set default authorization header if token exists
  if (storedToken) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }
}

// Add request interceptor to automatically add token
axiosInstance.interceptors.request.use(
  (config) => {
    // In public mode, never add authorization header
    if (!environment.publicMode) {
      const token = localStorage.getItem('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('access_token');
      delete axiosInstance.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);